var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2745_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.813C10.5593 21.813 9.18898 21.5019 7.9545 20.9427L3.21895 21.799C2.90868 21.8552 2.5922 21.7401 2.39026 21.498C2.18833 21.2558 2.1321 20.9239 2.24303 20.6287L3.58679 17.0536C2.69814 15.577 2.18702 13.8471 2.18702 12C2.18702 6.58045 6.58045 2.18701 12 2.18701C17.4196 2.18701 21.813 6.58045 21.813 12C21.813 17.4196 17.4196 21.813 12 21.813Z",
    fill: "url(#paint0_radial_2745_154)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2.43701C17.2818 2.43726 21.563 6.71915 21.563 12.0005C21.5627 17.2816 17.2816 21.5627 12.0005 21.563C10.5962 21.563 9.26069 21.2601 8.05811 20.7153L7.98682 20.6831L7.90967 20.6968L3.17432 21.5532C2.95274 21.5933 2.72587 21.5104 2.58154 21.3374C2.4556 21.1859 2.40911 20.9853 2.45264 20.7964L2.47705 20.7163L3.8208 17.1421L3.86377 17.0288L3.80127 16.9243C2.93553 15.4857 2.4371 13.8006 2.43701 12.0005C2.43701 6.719 6.71898 2.43701 12.0005 2.43701Z",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2745_154",
    x: 2.18701,
    y: 2.18701,
    width: 19.626,
    height: 20.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_2745_154"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2745_154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 2.35589) rotate(90) scale(19.4571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1880E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1574D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGradient);
export default __webpack_public_path__ + "static/media/message-gradient.ea8bd430820b71afa9b3885bbffc9782.svg";
export { ForwardRef as ReactComponent };